import _classCallCheck from "/srv/clients/sphs-frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/srv/clients/sphs-frontend/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/srv/clients/sphs-frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/srv/clients/sphs-frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/srv/clients/sphs-frontend/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import jsdiff from 'diff';
var fnMap = {
  'chars': jsdiff.diffChars,
  'words': jsdiff.diffWords,
  'sentences': jsdiff.diffSentences,
  'json': jsdiff.diffJson
};
/**
 * Display diff in a stylable form.
 *
 * Default is character diff. Change with props.type. Valid values
 * are 'chars', 'words', 'sentences', 'json'.
 *
 *  - Wrapping div has class 'Difference', override with props.className
 *  - added parts are in <ins>
 *  - removed parts are in <del>
 *  - unchanged parts are in <span>
 */

var Diff =
/*#__PURE__*/
function (_Component) {
  _inherits(Diff, _Component);

  function Diff() {
    _classCallCheck(this, Diff);

    return _possibleConstructorReturn(this, _getPrototypeOf(Diff).apply(this, arguments));
  }

  _createClass(Diff, [{
    key: "render",
    value: function render() {
      var diff = fnMap[this.props.type](this.props.inputA, this.props.inputB);
      var result = diff.map(function (part, index) {
        if (part.added) {
          return React.createElement('ins', {
            key: index
          }, part.value);
        }

        if (part.removed) {
          return React.createElement('del', {
            key: index
          }, part.value);
        }

        return React.createElement('span', {
          key: index
        }, part.value);
      });
      return React.createElement('div', {
        className: this.props.className
      }, result);
    }
  }]);

  return Diff;
}(Component);

export { Diff as default };
Diff.defaultProps = {
  inputA: '',
  inputB: '',
  type: 'chars',
  className: 'Difference'
};